export const purposes = [
    "The algorithm was designed to assist you in making course recommendations.", //functional
    "The algorithm was designed to help increase participation of undermatched and underrepresented students in AP science courses with the goal of increasing student academic skills and interest in STEM fields." //positive
];

export const purposeVideos = [
    "iuvhwIsp1-c", // functional
    "e17gf6FknqA" // positive
]